import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import GoogleButton from "@/components/GoogleButton";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ref = params.get("ref") || "";
  const roleParam = ["client", "coach", "room_manager"].includes(params.get("role")) ? params.get("role") : null;
  const [form, setForm] = useState({ email: "", password: "", name: "", role: roleParam || (ref ? "coach" : "client"), phone: "", referral_code: ref || undefined });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Compte créé, bienvenue !");
      navigate("/tableau-de-bord");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur d'inscription");
    } finally { setBusy(false); }
  };

  const RoleTile = ({ v, label, sub, color }) => (
    <button type="button" data-testid={`role-${v}`} onClick={() => setForm({ ...form, role: v })} className={`p-4 rounded-2xl border text-left transition ${form.role === v ? `border-${color}-500 bg-${color}-500/5` : "border-slate-200 bg-white hover:bg-slate-50"}`}>
      <div className="font-bold text-slate-900">{label}</div>
      <div className="text-xs text-slate-600 mt-1">{sub}</div>
    </button>
  );

  return (
    <div>
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 py-14">
        <h1 className="text-3xl font-extrabold text-slate-900">Créer un compte</h1>
        <p className="mt-1 text-slate-600">Rejoignez TymCoach en 30 secondes.</p>

        <div className="mt-6 grid sm:grid-cols-3 gap-3">
          <RoleTile v="client"       label="Particulier"       sub="Réserver à la séance"       color="emerald" />
          <RoleTile v="coach"        label="Coach"             sub="Trouver des salles"         color="orange"  />
          <RoleTile v="room_manager" label="Responsable Salle" sub="Rentabiliser mes créneaux" color="indigo"  />
        </div>

        <form onSubmit={submit} className="mt-6 space-y-3">
          <input data-testid="register-name" required placeholder="Nom complet" className="w-full border border-slate-200 rounded-xl p-3" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <input data-testid="register-email" required type="email" placeholder="Email" className="w-full border border-slate-200 rounded-xl p-3" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <input data-testid="register-password" required type="password" placeholder="Mot de passe (6+ caractères)" className="w-full border border-slate-200 rounded-xl p-3" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          <input data-testid="register-phone" placeholder="Téléphone (optionnel)" className="w-full border border-slate-200 rounded-xl p-3" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          <label className="flex items-start gap-2 text-xs text-slate-600">
            <input data-testid="accept-cgu" type="checkbox" required className="mt-0.5 accent-emerald-500" />
            <span>J'accepte les <Link to="/legal/cgu" className="underline" target="_blank">CGU</Link> et la <Link to="/legal/confidentialite" className="underline" target="_blank">politique de confidentialité</Link>.</span>
          </label>
          <button data-testid="register-submit" disabled={busy} className="sc-btn sc-btn-emerald w-full justify-center">{busy ? "Création…" : "Créer mon compte"}</button>
        </form>
        <div className="my-4 flex items-center gap-3 text-xs text-slate-400"><span className="h-px flex-1 bg-slate-200" />ou<span className="h-px flex-1 bg-slate-200" /></div>
        <GoogleButton role={form.role} label="S'inscrire avec Google" />

        <div className="mt-4 text-sm text-slate-600">Déjà un compte ? <Link className="text-emerald-700 font-semibold" to="/connexion">Se connecter</Link></div>
      </div>
      <Footer />
    </div>
  );
}
